import * as core from '../../../../../../../core'

import { query } from './change-impact-log.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impact.log',
    description: 'Table view of the change impact log',
    name: 'Change Impact Log',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
